import { startOfTomorrow } from 'date-fns/startOfTomorrow';
import { getZonedDate } from '@eika-infrastruktur/date';
const tomorrow = getZonedDate(startOfTomorrow());
export const paymentInitialState = {
    fromAccount: undefined,
    toAccount: undefined,
    amount: undefined,
    currency: 'NOK',
    note: '',
    kid: undefined,
    ownText: '',
    firstBankingDateFromToday: tomorrow,
    showFromAccounts: false,
    receiptType: undefined,
    immediate: false,
    futurePaymentAmount: undefined,
    acceptDuplicate: false,
    hasInitialKid: false,
    paymentDate: getZonedDate(),
};
export const getFutureState = (futurePayment) => ({
    ...paymentInitialState,
    paymentDate: getZonedDate(futurePayment.date),
    amount: Math.abs(futurePayment.amount),
    showFromAccounts: false,
    futurePaymentAmount: -futurePayment.amount,
    currency: futurePayment.currency,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9QYXltZW50L2Zvcm0vc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBRTNELE9BQU8sRUFBRSxZQUFZLEVBQWEsTUFBTSwwQkFBMEIsQ0FBQztBQWtCbkUsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFDLGVBQWUsRUFBRSxDQUFDLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQWlCO0lBQzdDLFdBQVcsRUFBRSxTQUFTO0lBQ3RCLFNBQVMsRUFBRSxTQUFTO0lBQ3BCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLEVBQUU7SUFDUixHQUFHLEVBQUUsU0FBUztJQUNkLE9BQU8sRUFBRSxFQUFFO0lBQ1gseUJBQXlCLEVBQUUsUUFBUTtJQUNuQyxnQkFBZ0IsRUFBRSxLQUFLO0lBQ3ZCLFdBQVcsRUFBRSxTQUFTO0lBQ3RCLFNBQVMsRUFBRSxLQUFLO0lBQ2hCLG1CQUFtQixFQUFFLFNBQVM7SUFDOUIsZUFBZSxFQUFFLEtBQUs7SUFDdEIsYUFBYSxFQUFFLEtBQUs7SUFDcEIsV0FBVyxFQUFFLFlBQVksRUFBRTtDQUM5QixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sY0FBYyxHQUFHLENBQUMsYUFBcUMsRUFBZ0IsRUFBRSxDQUFDLENBQUM7SUFDcEYsR0FBRyxtQkFBbUI7SUFDdEIsV0FBVyxFQUFFLFlBQVksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDO0lBQzdDLE1BQU0sRUFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUM7SUFDdEMsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixtQkFBbUIsRUFBRSxDQUFDLGFBQWEsQ0FBQyxNQUFNO0lBQzFDLFFBQVEsRUFBRSxhQUFhLENBQUMsUUFBUTtDQUNuQyxDQUFDLENBQUMifQ==